import * as React from 'react';
import { useEffect, useState } from 'react';
import {
    Grid,
    TextField,
} from '@mui/material';
import UpdateDeleteLine from 'src/components/Button/UpdateDeleteLine';
import DialogOtherActionsNextYear from "src/components/Dialog/FicheEEPBM/DialogOtherActionsNextYear";
import ASMAlert from 'src/components/Alert';
import { otherActionsNextYearService } from 'src/services';
import { useTranslation } from 'react-i18next';
import { OtherActionsNextYearModel } from 'src/models/businessManager/businessManager.model';

function OtherActionsNextYearItem(props) {
    const { REACT_APP_NOTIFICATION_DURATION } = process.env;
    const { t } = useTranslation();
    const lineColor = props.lineColor;
    const isVisu = props.isVisu;
    const [displayAlert, setDisplayAlert] = useState<boolean>(false);
    const [displayAlertError, setDisplayAlertError] = useState<boolean>(false);
    const [data, setData] = React.useState<OtherActionsNextYearModel>({
        id: 0,
        idEa: 0,
        actionType: '',
        motivationJustification: '',
        implementationSystems: ''
    });
    const [state, setState] = React.useState<OtherActionsNextYearModel>({
        id: 0,
        idEa: 0,
        actionType: '',
        motivationJustification: '',
        implementationSystems: ''
    });
    useEffect(() => {
        if (props.data != undefined) {
            setState({
                id: props.data.id ?? 0,
                idEa: props.data.idEa ?? 0,
                actionType: props.data.actionType ?? '',
                motivationJustification: props.data.motivationJustification ?? '',
                implementationSystems: props.data.implementationSystems ?? ''
            });
        }
        if (data.id == 0) {
            setData({
                id: props.data.id ?? 0,
                idEa: props.data.idEa ?? 0,
                actionType: props.data.actionType ?? '',
                motivationJustification: props.data.motivationJustification ?? '',
                implementationSystems: props.data.implementationSystems ?? ''
            });
        }
    }, [props.data]);

    const [openDialogUpdate, setOpenDialogUpdate] = React.useState(false);
    const handleOpenDialogUpdate = () => {
        setOpenDialogUpdate(true);
    }
    const handleCloseDialogUpdate = () => {
        setState(data);
        setOpenDialogUpdate(false);
    }
    const handleClickUpdate = () => {
        otherActionsNextYearService.update(data.id, state).then(response => {
            if (response.data.success) {
                setData(state);
                setDisplayAlert(true);
                setTimeout(() => {
                    setDisplayAlert(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            } else {
                setDisplayAlertError(true);
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            }
        }).catch(err => {
            setDisplayAlertError(true);
            setTimeout(() => {
                setDisplayAlertError(false);
            }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
        });
        setOpenDialogUpdate(false);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState({
            ...state,
            [name]: value
        });
    }

    return (
        <>
            <ASMAlert message={t('action.success')} severity="success" open={displayAlert} />
            <ASMAlert message={t('action.error')} severity="error" open={displayAlertError} />
            <>
                <Grid item xs={3} >
                    <TextField
                        label=""
                        variant="outlined"
                        fullWidth
                        name="actionType"
                        value={data.actionType}
                        multiline
                        inputProps={{
                            maxLength: 4094
                        }}
                        disabled={true}
                        style={{
                            backgroundColor: lineColor,
                            borderRadius: 6
                        }}
                    />
                </Grid>
                <Grid item xs={4} >
                    <TextField
                        label=""
                        variant="outlined"
                        fullWidth
                        name="motivationJustification"
                        value={data.motivationJustification}
                        multiline
                        inputProps={{
                            maxLength: 4094
                        }}
                        disabled={true}
                        style={{
                            backgroundColor: lineColor,
                            borderRadius: 6
                        }}
                    />
                </Grid>
                <Grid item xs={4} >
                    <TextField
                        label=""
                        variant="outlined"
                        fullWidth
                        name="implementationSystems"
                        value={data.implementationSystems}
                        multiline
                        inputProps={{
                            maxLength: 4094
                        }}
                        disabled={true}
                        style={{
                            backgroundColor: lineColor,
                            borderRadius: 6
                        }}
                    />
                </Grid>

                <Grid item xs={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                    <UpdateDeleteLine
                        isVisu={isVisu}
                        handleOpenDialogUpdate={handleOpenDialogUpdate}
                        dialogUpdate={
                            <DialogOtherActionsNextYear
                                data={state}
                                handleChange={handleChange}
                                openDialogUpdate={openDialogUpdate}
                                handleCloseDialogUpdate={handleCloseDialogUpdate}
                                handleClickUpdate={handleClickUpdate}
                                title={t('eepBm.otherActionsNPlus1.modifTitle')}
                            />
                        }
                    />
                    {props.deleteComponent}
                </Grid>
            </>
        </>
    );
}

export default OtherActionsNextYearItem;